(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/conditionals.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/conditionals.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
function ifIsProlongation(_ref) {
  let {
    params,
    calls
  } = _ref;
  return () => {
    const {
      wagerId
    } = params();
    if (wagerId) {
      return {
        calls: calls()
      };
    }
  };
}
function ifHasIncompleteWagers(_ref2) {
  let {
    params,
    calls
  } = _ref2;
  return () => {
    const {
      incompleteWagers
    } = params();
    if (incompleteWagers !== null && incompleteWagers !== void 0 && incompleteWagers.length) {
      return {
        calls: calls()
      };
    }
  };
}
function ifDrawHasClosed(_ref3) {
  let {
    params,
    calls
  } = _ref3;
  return () => {
    const {
      closedWager
    } = params();
    if (closedWager) {
      return {
        calls: calls()
      };
    }
  };
}
function ifDrawOpenIsToday(_ref4) {
  let {
    params,
    calls
  } = _ref4;
  return () => {
    const {
      wagers,
      draws,
      lastDrawDate
    } = params();
    const productOpenedToday = wagers.map(_ref5 => {
      let {
        bets
      } = _ref5;
      return bets[0].productId;
    }).find(productId => dateFns.isToday(new Date(draws[productId].regOpenTime)));
    const skipDialog = lastDrawDate && dateFns.isToday(new Date(lastDrawDate));
    if (productOpenedToday && !skipDialog) {
      return {
        calls: calls({
          productOpenedToday,
          regCloseTime: draws[productOpenedToday].regCloseTime
        })
      };
    }
  };
}
function ifHasClosedJokerDraws(_ref6) {
  let {
    params,
    calls
  } = _ref6;
  return () => {
    const {
      wagers,
      draws
    } = params();
    const productWithClosedJoker = wagers
    .filter(_ref7 => {
      let {
        bets
      } = _ref7;
      return bets.some(bet => productMapping.isJoker(bet.productId));
    })
    .map(_ref8 => {
      let {
        bets
      } = _ref8;
      return bets[0].productId;
    })
    .find(productId => !draws[productId].jokerDraw);
    if (productWithClosedJoker) {
      return {
        calls: calls({
          productWithClosedJoker
        })
      };
    }
  };
}
Object.assign(svs.numbergames.pay_numbergames, {
  ifIsProlongation,
  ifHasIncompleteWagers,
  ifDrawHasClosed,
  ifDrawOpenIsToday,
  ifHasClosedJokerDraws
});

 })(window);